import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";

// Regular imports (no lazy loading to avoid chunk loading errors)
import AddModule from "./pages/AddModule/AddModule";
import AddProcedure from "./pages/AddProcedure/AddProcedure";
import ApplicationSetup from "./pages/ApplicationSetup/ApplicationSetup";
import AuditTrail from "./pages/AuditTrail/AuditTrail";
import ViewAuditTrail from "./pages/AuditTrail/ViewAuditTrail";
import PreviewLayout from "./pages/AuditTrail/ActionComponents/NodeActions/Previews/PreviewLayout";
import ReviewLayout from "./pages/AuditTrail/ActionComponents/NodeActions/Previews/ReviewLayout";
import CopyMoveDeleteReviewLayout from "./pages/AuditTrail/ActionComponents/NodeActions/Previews/CopyMoveDeleteReviewLayout";
import ComparisonLayout from "./pages/AuditTrail/ActionComponents/NodeActions/Previews/ComparisonLayout";
import Login from "./pages/Auth/Login";
import EditProcedureRevision from "./pages/EditProcedureRevision/EditProcedureRevision";
import FormTemplateForm from "./pages/FormTemplates/FormTemplateForm";
import FormTemplates from "./pages/FormTemplates/FormTemplates";
import EditProcedureTemplateRule from "./pages/ProcedureTemplateRules/AddProcedureTemplateRules";
import ProcedureTemplateRules from "./pages/ProcedureTemplateRules/ProcedureTemplateRules";
import Products from "./pages/Products/Products";
import SearchQuery from "./pages/SearchQuery/SearchQuery";
import ProcedureCopySelectProcedure from "./pages/SectionElements/copy/ProcedureCopySelectProcedure";
import ProcedureSectionCopy from "./pages/SectionElements/copy/ProcedureSectionCopy";
import ProcedureSectionCopyPreview from "./pages/SectionElements/copy/ProcedureSectionCopyPreview";
import MovePreviewCopySelectProcedure from "./pages/SectionElements/copy/MovePreviewCopySelectProcedure";
import MovePreviewStepCopy from "./pages/SectionElements/copy/MovePreviewStepCopy";
import MovePreviewStepCopyPreview from "./pages/SectionElements/copy/MovePreviewStepCopyPreview";
import MyCanvas from "./pages/Canvas/MyCanvas";
import SectionForm from "./pages/SectionElements/SectionForm";
import SelectedPartPage from "./pages/SectionElements/SelectedPartPage";
import SelectedSectionElement from "./pages/SectionElements/SelectedSectionElement";
import SelectedSectionPage from "./pages/SectionElements/SelectedSectionPage";
import SelectedStepPage from "./pages/SectionElements/SelectedStepPage";
import SelectedSubstepPage from "./pages/SectionElements/SelectedSubstepPage";
import ProcedureAttachmentMove from "./pages/SectionElements/move/ProcedureAttachmentMove";
import ProcedureAttachmentMovePreview from "./pages/SectionElements/move/ProcedureAttachmentMovePreview";
import ProcedureCanvasMove from "./pages/SectionElements/move/ProcedureCanvasMove";
import ProcedureCanvasMovePreview from "./pages/SectionElements/move/ProcedureCanvasMovePreview";
import ProcedureRichTextMove from "./pages/SectionElements/move/ProcedureRichTextMove";
import ProcedureRichTextMovePreview from "./pages/SectionElements/move/ProcedureRichTextMovePreview";
import ProcedureSectionMove from "./pages/SectionElements/move/ProcedureSectionMove";
import ProcedureSectionMovePreview from "./pages/SectionElements/move/ProcedureSectionMovePreview";
import ProcedureStepMove from "./pages/SectionElements/move/ProcedureStepMove";
import ProcedureStepMovePreview from "./pages/SectionElements/move/ProcedureStepMovePreview";
import ProcedureSubstepMove from "./pages/SectionElements/move/ProcedureSubstepMove";
import ProcedureSubstepMovePreview from "./pages/SectionElements/move/ProcedureSubstepMovePreview";
import ProcedureVideoMove from "./pages/SectionElements/move/ProcedureVideoMove";
import ProcedureVideoMovePreview from "./pages/SectionElements/move/ProcedureVideoMovePreview";
import SuggestionRules from "./pages/SuggestionRules/SuggestionRules";
import SuggestionRuleForm from "./pages/SuggestionRules/SuggestionRulesForm";
import Tasks from "./pages/Tasks/Tasks";
import ActionItem from "./pages/Tasks/ActionItems/ActionItem";
import AddTrainingLog from "./pages/TrainingLog/AddTrainingLog";
import TrainingLogs from "./pages/TrainingLog/TrainingLogs";
import UnitForm from "./pages/Unit/UnitForm";
import Units from "./pages/Unit/Units";
import ProfilePage from "./pages/Users/Profile";
import UserForm from "./pages/Users/UserForm";
import Users from "./pages/Users/Users";
import ProcedureStepCopy from "./pages/SectionElements/copy/ProcedureStepCopy";
import ProcedureStepCopyPreview from "./pages/SectionElements/copy/ProcedureStepCopyPreview";
import ProcedureSubstepCopy from "./pages/SectionElements/copy/ProcedureSubstepCopy";
import ProcedureSubstepCopyPreview from "./pages/SectionElements/copy/ProcedureSubstepCopyPreview";
import ProcedureChildCopy from "./pages/SectionElements/copy/ProcedureChildCopy";
import ProcedureChildCopyPreview from "./pages/SectionElements/copy/ProcedureChildCopyPreview";
import ProcedureElementDelete from "./pages/SectionElements/delete/ProcedureElementDelete";
import ProcedureCopyPreview from "./pages/SectionElements/copy/ProcedureCopyPreview";
import ColorTextEditor from "./ColorTextEditor";
import CanvasTemplates from "./pages/CanvasTemplates/CanvasTemplates";
import VersionHistoryDetailsPage from "./pages/SectionElements/VersionHistoryDetailsPage";
import AddCanvasTemplate from "./pages/Canvas/AddCanvasTemplate";
import VersionHistoryRevisionsTable from "./pages/SubassemblyDetails/VersionHistoryRevisionsTable";
import PreviewNodes from "./pages/SubassemblyDetails/PreviewNodes";
import Page404 from "./pages/Page404";
import RevisionPreview from "./pages/AuditTrail/ActionComponents/MoveAction/RevisionPreview/RevisionPreview";
import MovePreviewLayout from "./pages/AuditTrail/ActionComponents/NodeActions/Previews/MovePreviewLayout";
import VersionHistoryCopyFlow from "./pages/AuditTrail/ActionComponents/VersionHistoryCopy/VersionHistoryCopyFlow";
import PastePositionSelector from "./pages/AuditTrail/ActionComponents/VersionHistoryCopy/components/PastePositionSelector";
import Document from "./pages/Documents/Document";
import MagivView from "./pages/Documents/MagicView/MagicView";
import ViewDocument from "./pages/Documents/components/ViewNodes/ViewDocument";
import ViewSection from "./pages/Documents/components/ViewNodes/ViewSection";
import ViewStep from "./pages/Documents/components/ViewNodes/ViewStep";
import ViewSubstep from "./pages/Documents/components/ViewNodes/ViewSubstep";
import ViewChildNode from "./pages/Documents/components/ViewNodes/ViewChildNode";
import CanvasStagePreviewPage from "./pages/Documents/components/CanvasStagePreviewPage";
import VersionHistoryPreview from "./pages/Documents/components/VersionHistoryPreview/VersionHistoryPreview";
import AddEditSection from "./pages/Section/AddEditSection";
import AddEditStep from "./pages/Step/AddEditStep";
import AttachmentPage from "./pages/Attachment/AttachmentPage";
import AddEditSubstep from "./pages/Substep/AddEditSubstep";
import VideoPage from "./pages/Video/VideoPage";
import RichTextPage from "./pages/RichText/RichTextPage";
import CanvasPage from "./pages/Canvas/CanvasPage";
import Backups from "./pages/Backups/Backups";
import CreateRevisionPreview from "./pages/AuditTrail/ActionComponents/RevisionAction/CreateRevisionPreview/CreateRevisionPreview";
import ModulePreview from "./pages/AuditTrail/ActionComponents/ModuleAction/ModulePreview";
import AppSetupPreview from "./pages/AuditTrail/ActionComponents/ApplicationSetup/AppSetupPreview";
import CurrentNode from "./pages/AuditTrail/ActionComponents/MoveAction/PreviewAndReview/Preview/CurrentNode";
import PreviewDeletedNode from "./pages/AuditTrail/ActionComponents/DeleteNodes/PreviewDeletedNode";
import PreviewItemCatTypeUpdate from "./pages/AuditTrail/ActionComponents/ItemCatTypeUpdate/PreviewItemCatTypeUpdate";

import { PUBLIC_SEGMENTS } from "./constants";

const AppRoutes = () => {
  const location = useLocation();
  return (
    <Routes key={location.pathname}>
      {/* Public Route - Login */}
      <Route path="/login" element={<Login />} />

      {/* Public Route - Live View (no auth required) */}
      <Route path="/live/:item_code" element={<MagivView />} />

      {/* Public Route - Edit View (no auth required) */}
      <Route path="/edit/:item_code" element={<MagivView />} />

      {/* Protected Routes - Require Authentication */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Products />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute>
            <Users />
          </ProtectedRoute>
        }
      />
      <Route
        path="/applicationSetup"
        element={
          <ProtectedRoute>
            <ApplicationSetup />
          </ProtectedRoute>
        }
      />
      <Route
        path="/add-user"
        element={
          <ProtectedRoute>
            <UserForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/units"
        element={
          <ProtectedRoute>
            <Units />
          </ProtectedRoute>
        }
      />
      <Route
        path="/color"
        element={
          <ProtectedRoute>
            <ColorTextEditor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/add-unit"
        element={
          <ProtectedRoute>
            <UnitForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/form-templates"
        element={
          <ProtectedRoute>
            <FormTemplates />
          </ProtectedRoute>
        }
      />
      <Route
        path="/add-form-template"
        element={
          <ProtectedRoute>
            <FormTemplateForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/suggestionRules"
        element={
          <ProtectedRoute>
            <SuggestionRules />
          </ProtectedRoute>
        }
      />
      <Route
        path="/add-suggestion-rule"
        element={
          <ProtectedRoute>
            <SuggestionRuleForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/new-module"
        element={
          <ProtectedRoute>
            <AddModule />
          </ProtectedRoute>
        }
      />
      <Route
        path="/new-procedure"
        element={
          <ProtectedRoute>
            <AddProcedure />
          </ProtectedRoute>
        }
      />
      <Route
        path="/search"
        element={
          <ProtectedRoute>
            <SearchQuery />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/preview"
        element={
          <ProtectedRoute>
            <PreviewNodes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/revision-submission/:partId/:revision/:type/:partNumber/:revisionId/:description"
        element={
          <ProtectedRoute>
            <Document />
          </ProtectedRoute>
        }
      />
      <Route
        path="/revision/:partId/:revisionId"
        element={
          <ProtectedRoute>
            <Document />
          </ProtectedRoute>
        }
      />
      <Route
        path="/view-revision/:part_id/:revision_id"
        element={
          <ProtectedRoute>
            <ViewDocument />
          </ProtectedRoute>
        }
      />
      <Route
        path="/view-section/:partnumber/:revision/:partId/:revisionId/:section_id_ref"
        element={
          <ProtectedRoute>
            <ViewSection />
          </ProtectedRoute>
        }
      />
      <Route
        path="/view-step/:partnumber/:revision/:partId/:revisionId/:section_id_ref/:step_id_ref"
        element={
          <ProtectedRoute>
            <ViewStep />
          </ProtectedRoute>
        }
      />
      <Route
        path="/view-substep/:partnumber/:revision/:partId/:revisionId/:section_id_ref/:step_id_ref/:substep_id_ref"
        element={
          <ProtectedRoute>
            <ViewSubstep />
          </ProtectedRoute>
        }
      />
      <Route
        path="/view-childnode/:partnumber/:revision/:partId/:revisionId/:section_id_ref/:step_id_ref/:child_node_id"
        element={
          <ProtectedRoute>
            <ViewChildNode />
          </ProtectedRoute>
        }
      />
      <Route
        path="/canvas-stage-preview"
        element={
          <ProtectedRoute>
            <CanvasStagePreviewPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/approve-revision/:partId/:revision/:type/:partNumber/:revisionId/:description"
        element={
          <ProtectedRoute>
            <Document />
          </ProtectedRoute>
        }
      />
      <Route
        path="/release-revision/:partId/:revision/:type/:partNumber/:revisionId/:description"
        element={
          <ProtectedRoute>
            <Document />
          </ProtectedRoute>
        }
      />
      <Route
        path="/released-revision/:partId/:revision/:type/:partNumber/:description/:revisionId"
        element={
          <ProtectedRoute>
            <Document />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rejected-revision/:partId/:revision/:type/:partNumber/:description/:status/:revisionId"
        element={
          <ProtectedRoute>
            <Document />
          </ProtectedRoute>
        }
      />
      <Route
        path="/archived-revision/:partId/:revision/:type/:partNumber/:description/:status/:revisionId"
        element={
          <ProtectedRoute>
            <Document />
          </ProtectedRoute>
        }
      />

      {/* Add / Edit Section Start here*/}
      <Route
        path="/add-new-section/:partnumber/:revision/:partId/:revisionId"
        element={
          <ProtectedRoute>
            <AddEditSection />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit-section/:partnumber/:revision/:partId/:revisionId/:section_id_ref"
        element={
          <ProtectedRoute>
            <AddEditSection mode="edit" />
          </ProtectedRoute>
        }
      />

      <Route
        path="/add-new-step/:partnumber/:revision/:partId/:revisionId/:section_id_ref"
        element={
          <ProtectedRoute>
            <AddEditStep mode="add" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit-step/:partnumber/:revision/:partId/:revisionId/:section_id_ref/:step_id_ref"
        element={
          <ProtectedRoute>
            <AddEditStep mode="edit" />
          </ProtectedRoute>
        }
      />

      <Route
        path="/add-new-substep/:partnumber/:revision/:partId/:revisionId/:section_id_ref/:step_id_ref"
        element={
          <ProtectedRoute>
            <AddEditSubstep />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit-substep/:partnumber/:revision/:partId/:revisionId/:section_id_ref/:step_id_ref/:substep_id_ref"
        element={
          <ProtectedRoute>
            <AddEditSubstep />
          </ProtectedRoute>
        }
      />

      <Route
        path="/add-new-attachment/:partnumber/:revision/:partId/:revisionId/:section_id_ref/:step_id_ref"
        element={
          <ProtectedRoute>
            <AttachmentPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit-attachment/:partnumber/:revision/:partId/:revisionId/:section_id_ref/:step_id_ref/:attachment_id_ref"
        element={
          <ProtectedRoute>
            <AttachmentPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/add-new-video/:partnumber/:revision/:partId/:revisionId/:section_id_ref/:step_id_ref"
        element={
          <ProtectedRoute>
            <VideoPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit-video/:partnumber/:revision/:partId/:revisionId/:section_id_ref/:step_id_ref/:video_id_ref"
        element={
          <ProtectedRoute>
            <VideoPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/add-new-richtext/:partnumber/:revision/:partId/:revisionId/:section_id_ref/:step_id_ref"
        element={
          <ProtectedRoute>
            <RichTextPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit-rich-text/:partnumber/:revision/:partId/:revisionId/:section_id_ref/:step_id_ref/:rich_text_id_ref"
        element={
          <ProtectedRoute>
            <RichTextPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/add-new-canvas/:partnumber/:revision/:partId/:revisionId/:section_id_ref/:step_id_ref"
        element={
          <ProtectedRoute>
            <CanvasPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit-canvas-new/:partnumber/:revision/:partId/:revisionId/:section_id_ref/:step_id_ref/:id"
        element={
          <ProtectedRoute>
            <CanvasPage />
          </ProtectedRoute>
        }
      />
      {/* Add / Edit Section End here*/}

      <Route
        path="/training-log"
        element={
          <ProtectedRoute>
            <TrainingLogs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/add-training-log"
        element={
          <ProtectedRoute>
            <AddTrainingLog />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-template-rules"
        element={
          <ProtectedRoute>
            <ProcedureTemplateRules />
          </ProtectedRoute>
        }
      />
      <Route
        path="/add-procedure-template-rule"
        element={
          <ProtectedRoute>
            <EditProcedureTemplateRule />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tasks"
        element={
          <ProtectedRoute>
            <Tasks />
          </ProtectedRoute>
        }
      />
      <Route
        path="/actionitems"
        element={
          <ProtectedRoute>
            <ActionItem />
          </ProtectedRoute>
        }
      />
      <Route
        path="/canvas-templates"
        element={
          <ProtectedRoute>
            <CanvasTemplates />
          </ProtectedRoute>
        }
      />
      <Route
        path="/add-canvas-template"
        element={
          <ProtectedRoute>
            <AddCanvasTemplate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/add-task"
        element={
          <ProtectedRoute>
            <Tasks />
          </ProtectedRoute>
        }
      />

      <Route
        path="/selected-section/:sectionsName/:sectionId/:partId/:revisionId/:partNumber/:revision/:section/:sectionId/:stepTitle/:siblingOrder"
        element={
          <ProtectedRoute>
            <SelectedSectionPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/canvas"
        element={
          <ProtectedRoute>
            <MyCanvas />
          </ProtectedRoute>
        }
      />
      <Route
        path="/selected-step/:sectionId/:revisionId/:partId/:stepId/:title/:partNumber/:revision/:richCount/:subsCount/:attachmentCount/:videoCount/:formCount/:canvasCount/:stepCount/:section/:stepTitle/:siblingOrder"
        element={
          <ProtectedRoute>
            <SelectedStepPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/version-history-preview"
        element={
          <ProtectedRoute>
            <VersionHistoryRevisionsTable />
          </ProtectedRoute>
        }
      />
      <Route
        path="/version-history-details"
        element={
          <ProtectedRoute>
            <VersionHistoryDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/selected-substep/:sectionId/:revisionId/:partId/:stepId/:stepTitle/:partNumber/:revision/:richCount/:subsCount/:attachmentCount/:videoCount/:formCount/:canvasCount/:stepCount/:section/:title/:substepId/:selectedSubstepTitle/:siblingOrder"
        element={
          <ProtectedRoute>
            <SelectedSubstepPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/selected-section-element/:type/:sectionId/:revisionId/:partId/:stepId/:stepTitle/:partNumber/:revision/:richCount/:subsCount/:attachmentCount/:videoCount/:formCount/:canvasCount/:stepCount/:section/:title/:substepId/:siblingOrder"
        element={
          <ProtectedRoute>
            <SelectedSectionElement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/selected-partno/:title/:partId/:revisionId/:partNumber/:revision/:siblingOrder/:type"
        element={
          <ProtectedRoute>
            <SelectedPartPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/section/:sectionId/form/:elementId/:partId/:revisionId/:stepId/:substepId/:partNumber/:title/:elementTitle/:revision/:stepTitle/:section/:siblingOrder"
        element={
          <ProtectedRoute>
            <SectionForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit-procedure-revision/:revisionId"
        element={
          <ProtectedRoute>
            <EditProcedureRevision />
          </ProtectedRoute>
        }
      />

      <Route
        path="/edit-canvas/:sectionId/:partId/:revisionId/:stepId/:substepId/:partNumber/:elementTitle/:revision/:stepTitle/:section/:siblingOrder/:elementType/:id"
        element={
          <ProtectedRoute>
            <CanvasPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/procedure-section-move"
        element={
          <ProtectedRoute>
            <ProcedureSectionMove />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-section-copy"
        element={
          <ProtectedRoute>
            <ProcedureSectionCopy />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-section-delete"
        element={
          <ProtectedRoute>
            <ProcedureElementDelete />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-step-delete"
        element={
          <ProtectedRoute>
            <ProcedureElementDelete />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-substep-delete"
        element={
          <ProtectedRoute>
            <ProcedureElementDelete />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-child-delete"
        element={
          <ProtectedRoute>
            <ProcedureElementDelete />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-copy"
        element={
          <ProtectedRoute>
            <ProcedureCopyPreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-copy-move-preview"
        element={
          <ProtectedRoute>
            <MovePreviewCopySelectProcedure />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-section-copy-preview"
        element={
          <ProtectedRoute>
            <ProcedureSectionCopyPreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-step-copy"
        element={
          <ProtectedRoute>
            <ProcedureStepCopy />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-step-copy-move-preview"
        element={
          <ProtectedRoute>
            <MovePreviewStepCopy />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-step-copy-preview"
        element={
          <ProtectedRoute>
            <ProcedureStepCopyPreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-step-copy-preview-move"
        element={
          <ProtectedRoute>
            <MovePreviewStepCopyPreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-substep-copy"
        element={
          <ProtectedRoute>
            <ProcedureSubstepCopy />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-substep-copy-preview"
        element={
          <ProtectedRoute>
            <ProcedureSubstepCopyPreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-child-copy"
        element={
          <ProtectedRoute>
            <ProcedureChildCopy />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-child-copy-preview"
        element={
          <ProtectedRoute>
            <ProcedureChildCopyPreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-section-move-preview"
        element={
          <ProtectedRoute>
            <ProcedureSectionMovePreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-copy-select-procedure"
        element={
          <ProtectedRoute>
            <ProcedureCopySelectProcedure />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-step-move"
        element={
          <ProtectedRoute>
            <ProcedureStepMove />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-step-move-preview"
        element={
          <ProtectedRoute>
            <ProcedureStepMovePreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-substep-move"
        element={
          <ProtectedRoute>
            <ProcedureSubstepMove />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-substep-move-preview"
        element={
          <ProtectedRoute>
            <ProcedureSubstepMovePreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-canvas-move"
        element={
          <ProtectedRoute>
            <ProcedureCanvasMove />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-canvas-move-preview"
        element={
          <ProtectedRoute>
            <ProcedureCanvasMovePreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-video-move"
        element={
          <ProtectedRoute>
            <ProcedureVideoMove />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-video-move-preview"
        element={
          <ProtectedRoute>
            <ProcedureVideoMovePreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-attachment-move"
        element={
          <ProtectedRoute>
            <ProcedureAttachmentMove />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-attachment-move-preview"
        element={
          <ProtectedRoute>
            <ProcedureAttachmentMovePreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-rich-text-move"
        element={
          <ProtectedRoute>
            <ProcedureRichTextMove />
          </ProtectedRoute>
        }
      />
      <Route
        path="/procedure-rich-text-move-preview"
        element={
          <ProtectedRoute>
            <ProcedureRichTextMovePreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-trail"
        element={
          <ProtectedRoute>
            <AuditTrail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/backups"
        element={
          <ProtectedRoute>
            <Backups />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-trail/:audit_trail_id"
        element={
          <ProtectedRoute>
            <ViewAuditTrail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-trail/preview/:audit_trail_id"
        element={
          <ProtectedRoute>
            <PreviewLayout />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-trail/item_type_cat_update_preview/:audit_trail_id"
        element={
          <ProtectedRoute>
            <PreviewItemCatTypeUpdate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-trail/preview-current-node/:audit_trail_id"
        element={
          <ProtectedRoute>
            <CurrentNode />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-trail/preview-deleted-node/:audit_trail_id"
        element={
          <ProtectedRoute>
            <PreviewDeletedNode />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-trail/review/:audit_trail_id"
        element={
          <ProtectedRoute>
            <ReviewLayout />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-trail/reviewcopymovedelete/:audit_trail_id"
        element={
          <ProtectedRoute>
            <CopyMoveDeleteReviewLayout />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-trail/comparison/:audit_trail_id"
        element={
          <ProtectedRoute>
            <ComparisonLayout />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-trail/move-copy-delete-preview/:audit_trail_id"
        element={
          <ProtectedRoute>
            <RevisionPreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/document-version-history/:audit_trail_id"
        element={
          <ProtectedRoute>
            <VersionHistoryPreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-trail/move-preview/:audit_trail_id"
        element={
          <ProtectedRoute>
            <MovePreviewLayout />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-trail/version-history-copy/:audit_trail_id"
        element={
          <ProtectedRoute>
            <VersionHistoryCopyFlow />
          </ProtectedRoute>
        }
      />
      <Route
        path="/paste-position-selector"
        element={
          <ProtectedRoute>
            <PastePositionSelector />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-trail/revision-preview/:audit_trail_id"
        element={
          <ProtectedRoute>
            <CreateRevisionPreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-trail/module-preview/:audit_trail_id"
        element={
          <ProtectedRoute>
            <ModulePreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/404"
        element={
          <ProtectedRoute>
            <Page404 />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-trail/appsetup-preview/:audit_trail_id"
        element={
          <ProtectedRoute>
            <AppSetupPreview />
          </ProtectedRoute>
        }
      />
      <Route
        path="*"
        element={
            <Page404 />
        }
      />
    </Routes>
  );
};

export default AppRoutes;
